import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: 'home/ajustes', loadChildren: './pages/options/options.module#OptionsPageModule' },
  { path: 'home/:object', loadChildren: './pages/dashboard/dashboard.module#DashboardPageModule' },
  { path: 'canvas/:object', loadChildren: './pages/canvas/canvas.module#CanvasPageModule' },
  { path: 'test/resultados/:object', loadChildren: './pages/results/results.module#ResultsPageModule' },
  { path: 'test/:id', loadChildren: './pages/tests/tests.module#TestsPageModule' },
  { path: 'registro', loadChildren: './pages/register/register.module#RegisterPageModule' },
  { path: '**', redirectTo: 'notfound', pathMatch: 'full' },
  { path: 'notfound', loadChildren: './pages/error/error.module#ErrorPageModule' },
  { path: 'auth', loadChildren: './pages/auth/auth.module#AuthPageModule' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
